import PropTypes from "prop-types";

const NoDataAvailableChecker = (data) => {
    // If data is null or undefined, return true (No Data)
    if (data === null || data === undefined) {
        return true;
    }

    if (typeof data === "object") {
        return Object.keys(data).length === 0;
    }

    // Handle other cases (empty array, empty string, zero, etc.)
    if (
        data === 0 ||
        (Array.isArray(data) && data.length === 0) ||
        (typeof data === "string" && data.trim() === "")
    ) {
        return true;
    }

    return false;
};

NoDataAvailableChecker.propTypes = {
    data: PropTypes.any,
};

export default NoDataAvailableChecker;
